module.exports = __webpack_public_path__ + "static/media/LL.48c57171.webp";